import { Card } from "@types"
import {
  BluePricingCard,
  DarkBluePricingCard,
  GrayPricingCard,
  GreenPricingCard,
  OrangePricingCardProps,
  PurpleOrangePricingCard,
  PurplePricingCard,
} from "@components"
import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface CategoryPricingCardProps {
  cards: Card
  setSelectedCard: Dispatch<SetStateAction<Card | undefined>>
  setShowQuote: Dispatch<SetStateAction<boolean>>
}
export const CategoryPricingCard = ({
  cards,
  setSelectedCard,
  setShowQuote,
}: CategoryPricingCardProps) => {
  return (
    <div
      className={`lg:col-span-6 col-span-16 col-start-2 mt-4 ${
        cards.type === "darkBlue" && "lg:col-span-7"
      }`}
    >
      {/* 
      {[...Array(3)].map((_, i) => (
        <div className="bg-input py-8 rounded-lg col-span-6">
          <div className="flex rounded-lg mx-auto bg-btn bg-glass w-4/5">
            <div className="text-center w-full rounded-lg">
              <p className="text-purple text-nowrap text-xs p-2">
                Most Popular for Large Business
              </p>
            </div>
          </div>
          <div className="pt-8 px-5">
            <div>
              <h3 className="text-5xl font-semibold text-black text-center">
                $20.00
              </h3>
              <p className="text-black text-center pt-3">
                Branding & UI/UX Design & Development & SEO & Marketing
              </p>
            </div>
            <div className="flex justify-center pt-4">
              <hr className="w-4/6 opacity-30" />
            </div>
            <div className="relative w-fit mx-auto">
              <div className="box-blur h-2"></div>
              <p className="text-black text-center text-lg font-semibold pt-3">
                Branding
              </p>
            </div>
            
            {[...Array(3)].map((_, i) => (
              <div className="text-black flex gap-2 items-center text-xs font-normal pt-2">
                <p>✓</p>
                <p className="text-gray">
                  1 Landing Page (Figma, Adobe XD, Sketch, Adobe Photoshop)
                </p>
              </div>
            ))}
              
            <div className="relative w-fit mx-auto pt-5">
              <div className="box-blur h-2"></div>
              <p className="text-black text-center text-lg font-semibold pt-3">
                TECHNOLOGY{" "}
                <span className="text-[10px] font-normal">
                  (Custom Selection upon your Need)
                </span>
              </p>
            </div>
            <div className="text-white grid-container px-16 pt-2 gap-2">
              {[...Array(3)].map((_, i) => (
                <div className=" col-span-8 my-1 gap-2 flex items-center">
                  <div className="checkbox cursor-pointer border border-[#7B68EC] w-6 h-6">
                     {checkboxes?.isChecked && (
                    <div className="checked bg-[#7B68EC] w-full text-center text-white">
                      ✓
                    </div>
                  )} 
                  </div>
                  <p className="text-black text-xs">Webflow</p>
                </div>
              ))}
            </div>
            <div>
              <p className="text-black text-xs text-center pt-8">
                We will update you on our progress on a daily basis, but for the
                safe side, we will deliver the entire project in 30 days. After
                Completion the project. We will provide SEO & Marketing Support
                for the <span className="text-yellow-400">“One Month’’</span>
              </p>
            </div>
            <div className="pt-4">
              <button className="bg-btn bg-glass text-black w-full p-2 rounded-lg">
                Download Quote
              </button>
            </div>
          </div>
        </div>
      ))}
      */}
      {/* startup-business-with-blue */}
      {cards.type === "blue" && (
        <BluePricingCard
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}
      {/* gray-card */}
      {cards.type === "gray" && (
        <GrayPricingCard
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}
      {/* green-card */}
      {cards.type === "green" && (
        <GreenPricingCard
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}
      {/* purple-card */}
      {cards.type === "purple" && (
        <PurplePricingCard
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}
      {/* blue-card */}
      {cards.type === "darkBlue" && (
        <DarkBluePricingCard
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}
      {/* orange-card */}
      {cards.type === "orange" && (
        <OrangePricingCardProps
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}
      {/* purple-orange-card */}
      {cards.type === "purpleOrange" && (
        <PurpleOrangePricingCard
          setSelectedCard={setSelectedCard}
          setShowQuote={setShowQuote}
          cards={cards}
        />
      )}

      {/* <div className="bg-medium-business py-4 shadow-lg border-b-2 border-white rounded-lg col-span-6">
        <div className="flex rounded-2xl mx-auto bg-light-green w-3/5">
          <div className="text-center w-full rounded-lg">
            <p className="text-green font-semibold text-nowrap text-sm p-2">
              Most Popular for Medium Business
            </p>
          </div>
        </div>
        <div className="pt-8 px-10">
          <div>
            <h3 className="text-6xl font-semibold text-green text-center">
              $20.00
            </h3>
            <p className="text-black text-center pt-3">
              Branding & UI/UX Design & Development & SEO & Marketing
            </p>
            <p className="text-green font-semibold text-center pt-3">
              15 Pages Website Design
            </p>
          </div>
          <div className="flex justify-center pt-4">
            <hr className="w-4/6 opacity-30" />
          </div>
          <div className="relative w-fit mx-auto">
            <div className="box-blur h-2"></div>
            <p className="text-black text-center text-lg font-semibold pt-3">
              Branding
            </p>
          </div>
          {[...Array(3)].map((_, i) => (
            <div className="text-black flex gap-2 items-center text-xs font-normal pt-2">
              <p>✓</p>
              <p className="text-gray">
                1 Landing Page{" "}
                <span className="text-[10px] text-green font-bold">
                  (Figma, Adobe XD, Sketch, Adobe Photoshop)
                </span>
              </p>
            </div>
          ))}
          <div className="relative w-fit mx-auto pt-5">
            <div className="box-blur h-2"></div>
            <p className="text-black text-center text-lg font-semibold pt-3">
              TECHNOLOGY{" "}
              <span className="text-[10px] font-normal">
                (Custom Selection upon your Need)
              </span>
            </p>
          </div>
          <div className="text-white grid-container px-16 pt-2 gap-2">
            {[...Array(3)].map((_, i) => (
              <div className=" col-span-8 my-1 gap-2 flex items-center">
                <div className="checkbox cursor-pointer border border-[#7B68EC] w-6 h-6"></div>
                <p className="text-black text-xs">Webflow</p>
              </div>
            ))}
          </div>
          <div>
            <p className="text-black text-xs text-center pt-8">
              We will update you on our progress on a daily basis, but for the
              safe side, we will deliver the entire project in 30 days. After
              Completion the project. We will provide SEO & Marketing Support
              for the <span className="text-yellow-400">“One Month’’</span>
            </p>
          </div>
          <div className="pt-4">
            <button className="border border-black text-sm py-3 text-black w-full p-2 rounded-3xl">
              Download Quote
            </button>
          </div>
        </div>
      </div> */}
      {/* large-business-with-blue */}
      {/* <div className="bg-large-business py-4 shadow-lg border-b-2 border-white rounded-lg col-span-6">
        <div className="flex rounded-2xl mx-auto bg-light-purple w-3/5">
          <div className="text-center w-full rounded-lg">
            <p className="text-purple font-bold text-nowrap text-sm p-2">
              Most Popular for Large Business
            </p>
          </div>
        </div>
        <div className="pt-8 px-5">
          <div>
            <h3 className="text-5xl font-semibold text-purple text-center">
              $20.00
            </h3>
            <p className="text-black text-center pt-3">
              Branding & UI/UX Design & Development & SEO & Marketing
            </p>
            <p className="text-purple font-semibold text-center pt-3">
              15 Pages Website Design
            </p>
          </div>
          <div className="flex justify-center pt-4">
            <hr className="w-4/6 opacity-30" />
          </div>
          <div className="relative w-fit mx-auto">
            <div className="box-blur h-2"></div>
            <p className="text-black text-center text-lg font-semibold pt-3">
              Branding
            </p>
          </div>
          {[...Array(3)].map((_, i) => (
            <div className="text-black flex gap-2 items-center text-xs font-normal pt-2">
              <p>✓</p>
              <p className="text-gray">
                1 Landing Page (Figma, Adobe XD, Sketch, Adobe Photoshop)
              </p>
            </div>
          ))}
          <div className="relative w-fit mx-auto pt-5">
            <div className="box-blur h-2"></div>
            <p className="text-black text-center text-lg font-semibold pt-3">
              TECHNOLOGY{" "}
              <span className="text-[10px] font-normal">
                (Custom Selection upon your Need)
              </span>
            </p>
          </div>
          <div className="text-white grid-container px-16 pt-2 gap-2">
            {[...Array(3)].map((_, i) => (
              <div className=" col-span-8 my-1 gap-2 flex items-center">
                <div className="checkbox cursor-pointer border border-[#7B68EC] w-6 h-6"></div>
                <p className="text-black text-xs">Webflow</p>
              </div>
            ))}
          </div>
          <div>
            <p className="text-black text-xs text-center pt-8">
              We will update you on our progress on a daily basis, but for the
              safe side, we will deliver the entire project in 30 days. After
              Completion the project. We will provide SEO & Marketing Support
              for the <span className="text-yellow-400">“One Month’’</span>
            </p>
          </div>
          <div className="pt-4">
            <button className="border border-black text-sm py-3 text-black w-full p-2 rounded-3xl">
              Download Quote
            </button>
          </div>
        </div>
      </div> */}
      {/* Enterprise-business-with-blue */}
      {/* <div className="bg-enterprise-business py-4 shadow-lg rounded-lg col-span-6">
        <div className="flex rounded-2xl mx-auto bg-dark-purple w-3/5">
          <div className="text-center w-full rounded-lg">
            <p className="text-white font-bold text-nowrap text-sm p-2">
              Most Popular for Enterprise
            </p>
          </div>
        </div>
        <div className="pt-8 px-5">
          <div>
            <h3 className="text-5xl font-semibold text-white text-center">
              BOOK A CALL
            </h3>
            <p className="text-white text-center pt-3">
              Branding & UI/UX Design & Development & SEO & Marketing
            </p>
            <p className="text-white font-semibold text-center pt-3">
              15 Pages Website Design
            </p>
          </div>
          <div className="flex justify-center pt-4">
            <hr className="w-4/6 opacity-30" />
          </div>
          <div className="relative w-fit mx-auto">
            <div className="box-blur h-2"></div>
            <p className="text-white text-center text-lg font-semibold pt-3">
              Branding
            </p>
          </div>
          {[...Array(3)].map((_, i) => (
            <div className="text-white flex gap-2 items-center text-xs font-normal pt-2">
              <p>✓</p>
              <p className="text-white">
                1 Landing Page (Figma, Adobe XD, Sketch, Adobe Photoshop)
              </p>
            </div>
          ))}
          <div className="relative w-fit mx-auto pt-5">
            <div className="box-blur h-2"></div>
            <p className="text-white text-center text-lg font-semibold pt-3">
              TECHNOLOGY{" "}
              <span className="text-[10px] font-normal">
                (Custom Selection upon your Need)
              </span>
            </p>
          </div>
          <div className="text-white grid-container px-16 pt-2 gap-2">
            {[...Array(3)].map((_, i) => (
              <div className=" col-span-8 my-1 gap-2 flex items-center">
                <div className="checkbox cursor-pointer border border-white w-6 h-6"></div>
                <p className="text-white text-xs">Webflow</p>
              </div>
            ))}
          </div>
          <div>
            <p className="text-white text-xs text-center pt-8">
              We will update you on our progress on a daily basis, but for the
              safe side, we will deliver the entire project in 30 days. After
              Completion the project. We will provide SEO & Marketing Support
              for the <span className="text-yellow-400">“One Month’’</span>
            </p>
          </div>
          <div className="pt-4">
            <button className="border border-black text-sm py-3 text-black w-full p-2 rounded-3xl">
              Download Quote
            </button>
          </div>
        </div>
      </div> */}
    </div>
  )
}
